import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['languageSelect']

  declare languageSelectTarget: HTMLSelectElement;

  connect(): void {
    let $languageSelect = $(this.languageSelectTarget).select2();

    $languageSelect.on('change', this.changeLanguage.bind(this));
  }

  changeLanguage(event: Event): void {
    const selectedLocale = (event.target as HTMLSelectElement).value;

    const url = new URL(window.location.href);
    url.searchParams.set('locale', selectedLocale);
    window.location.href = url.toString();
  }
}
